<template>
  <div>
    <div class="header">
      <div class="logo">
        <img src="@/assets/img/easy-delivery.svg" alt="Logo Easy Delivery" />
      </div>

      <div class="welcome">
        <div v-if="done !== 100">
          <h1>
            Olá {{ oUser && oUser.name ? oUser.name.split(' ')[0] : '' }}!
          </h1>
          <h2>Configure sua loja para começar a usá-la.</h2>
          <div class="progress">
            <div class="bar">
              <div class="percent" :style="`width: ${done}%;`"></div>
            </div>
          </div>

          <p class="percent">{{ done }}%</p>
        </div>
        <div v-else>
          <h1>Conta configurada com sucesso!</h1>
          <h2>Você já pode acessar a sua conta.</h2>
          <base-button
            text="Começar"
            class="w-100 big start"
            @click="saveAndRedirect"
          />
        </div>
      </div>
    </div>

    <div class="main">
      <div class="configurations">
        <div v-for="(oStep, iStep) in steps" :key="iStep" class="route">
          <base-box
            class="config"
            :class="{
              done: oStep.status === 2,
              incomplete: oStep.status === 1,
            }"
          >
            <p class="icon" :class="{ done: oStep.status === 2 }">
              <i :class="oStep.icon"></i>
            </p>
            <p class="label">{{ oStep.label }}</p>
            <span v-if="oStep.status === 1" class="incomplete">Incompleto</span>
            <span v-else-if="oStep.status === 2" class="done">Configurado</span>
            <span v-else class="setup">Não configurado</span>
            <router-link :to="oStep.route" class="router-link">
              <base-button design="four" class="w-100">Configurar</base-button>
            </router-link>
          </base-box>
        </div>
      </div>

      <div class="d-flex justify-end">
        <button class="logout" @click.prevent="logout()">SAIR</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import SocketIO from 'easyjs/lib/Socket/SocketIO';
import BaseTitle from '@/components/Title';
import BaseBox from '@/components/Box';
import BaseButton from '@/components/Button';
import { setXUserKey } from '@/plugins/account';
import store from '@/store';
import {
  onBoardProgress,
  verifyProgress,
} from '@/plugins/core/schema/onBoardEnum';
import StoreAPI from '@/api/store';

export default {
  data() {
    return {
      currentProgress: 0,
      done: 0,
      steps: [
        {
          route: 'informacoes',
          label: StringLanguage.storeInformations,
          icon: 'fal fa-store',
          status: 0,
        },
        {
          route: 'localizacao',
          label: 'Localização',
          icon: 'fal fa-map-marker-alt',
          status: 0,
        },
        {
          route: 'regioes',
          label: StringLanguage.deliveryRegions,
          icon: 'fal fa-map-marked-alt',
          status: 0,
        },
        {
          route: 'horario',
          label: 'Horário de atendimento',
          icon: 'fal fa-clock',
          status: 0,
        },
        {
          route: 'pagamento',
          label: StringLanguage.payment,
          icon: 'fal fa-credit-card-blank',
          status: 0,
        },
      ],
    };
  },
  created() {
    this.verifyProgressLocal();
    this.changeSteps();
  },
  watch: {
    configurations() {
      this.verifyProgressLocal();
      this.changeSteps();
    },
  },
  computed: {
    ...mapState({
      configurations: (state) => state.store.configurations,
      onBoardDone: (state) => state.store.onBoardDone,
      oUser: (state) => state.account.oUser,
    }),
  },
  components: {
    BaseTitle,
    BaseBox,
    BaseButton,
  },
  methods: {
    logout() {
      setXUserKey();
      this.$store.dispatch('account/cleanUser');
      SocketIO.close();
      this.$router.push({ name: 'login' });
    },
    async saveAndRedirect() {
      try {
        await store.commit('store/setOnBoardDone', true);
        await store.commit('store/setNoTemplate', false);
        const response = await StoreAPI.storeConfiguration({
          on_board_progress: 246,
          published: true,
        });
        if (response.getErrors([]).length == 0) {
          const config = await this.$store.dispatch('store/getConfigurations');

          this.$router.push({ name: 'pedidos' });
        }
      } catch (err) {
        console.log(err);
        alert(StringLanguage.saveError);
      }
    },
    verifyProgressLocal() {
      const progress = verifyProgress(this.configurations);

      if (progress !== this.currentProgress) {
        this.currentProgress = progress;
        try {
          StoreAPI.storeConfiguration({
            on_board_progress: this.currentProgress,
          });
        } catch (err) {
          console.log(err);
        }
      }
    },
    changeSteps() {
      const progress = this.currentProgress;

      // limpa dados atuais
      this.done = 0;
      this.steps = this.steps.map((step) => ({ ...step, status: 0 }));

      if (progress & onBoardProgress.STEP_1_INCOMPLETE) {
        this.steps[0].status = 1;
      }
      if (progress & onBoardProgress.STEP_1_DONE) {
        this.steps[0].status = 2;
        this.done += 20;
      }
      if (progress & onBoardProgress.STEP_2_DONE) {
        this.steps[1].status = 2;
        this.done += 20;
      }
      if (progress & onBoardProgress.STEP_3_INCOMPLETE) {
        this.steps[2].status = 1;
      }
      if (progress & onBoardProgress.STEP_3_DONE) {
        this.steps[2].status = 2;
        this.done += 20;
      }
      if (progress & onBoardProgress.STEP_4_DONE) {
        this.steps[3].status = 2;
        this.done += 20;
      }
      if (progress & onBoardProgress.STEP_5_DONE) {
        this.steps[4].status = 2;
        this.done += 20;
      }
      if (progress & onBoardProgress.STEP_6_DONE) {
        this.steps[4].status = 2;
        this.done += 20;
      }
    },
  },
};
</script>

<style scoped>
.header {
  margin: -40px -40px -20px;
  padding: 40px 40px 20px;
  background: var(--background-up);
}

.main {
  margin: 15px -40px -40px -40px;
  padding: 150px 50px 0;
  height: 100%;
  border-top: 1px solid #5b5e6a66;
}

.logout {
  color: var(--label-primary);
  font-size: 12px;
  margin-left: auto;
  border-radius: 0;
  padding-bottom: 2px;
  border: none;
  background: none;
  border-bottom: 1px solid transparent;
  transform: translateY(45px);
  cursor: pointer;
}

.logout:hover {
  color: #fff;
  border-color: #fff;
}

.configurations {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

@media screen and (max-width: 1125px) {
  .configurations {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media screen and (max-width: 855px) {
  .configurations {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 645px) {
  .configurations {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (max-width: 500px) {
  .configurations {
    grid-template-columns: repeat(1, 1fr);
  }
}

.logo {
  max-width: 190px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
}

.logo img {
  max-width: 100%;
  max-height: 100%;
}

.welcome {
  font-family: 'Rubik', sans-serif;
  width: 100%;
  text-align: center;
  margin: 23px 0 25px 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.welcome h1 {
  font-size: 22px;
  font-weight: 500;
  color: #d9d9d9;
  line-height: 27px;
}

.welcome h2 {
  margin-top: 10px;
  font-size: 16px;
  line-height: 19px;
  font-weight: 300;
  color: #aaaaab;
}

.start {
  max-width: 300px;
  margin: auto;
  margin-top: 45px;
}

.route {
  margin-bottom: 20px;
}

.router-link {
  text-decoration: none;
  width: 100%;
}

.config {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px 15px;
  overflow: initial;
  border-radius: 10px;
  margin-bottom: 0;
}

.config span {
  font-weight: bold;
  padding: 5px 15px;
  font-size: 12px;
  line-height: 15px;
  margin-bottom: 30px;
  border-radius: 5px;
}

.config span.setup {
  background: var(--box-up);
  color: #aaaaab;
}

.config span.done {
  background: #305c55;
  color: #0dc59d;
}

.config span.incomplete {
  background: #615850;
  color: #ffcc99a8;
}

.config .icon {
  font-size: 20px;
  color: #aaa;
  position: absolute;
  top: -38px;
  width: 76px;
  height: 76px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  background: #42464a;
}

.config .icon.done {
  color: #0dc59d;
}

.config .label {
  font-size: 14px;
  color: #cccccc;
  margin-bottom: 25px;
  padding-bottom: 25px;
  padding-top: 40px;
  border-bottom: 1px solid #ffffff17;
  width: 100%;
  text-align: center;
  line-height: 1.4;
  font-weight: 500;
  min-height: 50px;
  font-family: 'Rubik', sans-serif;
}

.progress {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 25px;
}

.progress .bar {
  height: 5px;
  width: 230px;
  background: #414347;
  border-radius: 30px;
  overflow: hidden;
}

.progress div.percent {
  height: 100%;
  background: #ff478f;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease-in-out;
}

p.percent {
  color: var(--label-primary);
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  margin-top: 8px;
}

@media screen and (max-height: 768px) {
  .logout {
    transform: translateY(20px);
    margin-bottom: 60px;
  }
}

@media screen and (max-width: 991px) {
  .welcome h1 {
    font-size: 16px;
    line-height: 20px;
  }

  .welcome h2 {
    font-size: 12px;
    line-height: 15px;
  }
  .header {
    margin: 0;
    padding: 30px 15px;
    position: fixed;
    width: 100%;
    z-index: 5;
    top: 0;
    left: 0;
    right: 0;
    box-shadow: 0 0 30px rgb(0 0 0 / 5%);
  }
  .main {
    margin: 30px -15px -25px -15px;
    padding: 250px 30px 0;
  }
  .config {
    margin-bottom: 20px;
  }
  .config span {
    margin-bottom: 25px;
  }
  .config .icon {
    font-size: 16px;
  }
  .welcome {
    margin-bottom: 0;
  }
  .welcome h2 {
    font-size: 14px;
  }
  .start {
    margin-top: 35px;
  }
}
</style>
